import React from 'react'
import { Space, TextBody } from '@ally/metronome-ui'
import AccountGroups from './AccountGroups'
import Accounts from './Accounts'
import { DataTypeName, DataType } from '../types'

const OrganizeAccounts: React.FC<{
  handleRef: (el: HTMLElement | null) => void
  onListChange: (type: DataTypeName, list: DataType<DataTypeName>[]) => void
}> = ({ handleRef, onListChange }) => {
  return (
    <>
      <Space mb="md">
        <TextBody tag="p" size="sm" tabIndex={-1} ref={handleRef}>
          Prioritize your accounts for easy access to what&apos;s important to
          you.
        </TextBody>
      </Space>
      <AccountGroups onListChange={onListChange} />
      <Accounts onListChange={onListChange} />
    </>
  )
}

export default OrganizeAccounts
